import EndpointsBase from "../EndpointsBase";

class IPackEndpoints extends EndpointsBase {
  cancelSortBox(
    SortBoxID: number,
    TooBigSkuIDs: number[],
    isPaused: boolean,
    approvedBy: string | null,
    isFailure: boolean = false,
    isScanIdValidationCancelSortboxRequired: boolean = false
  ) {
    return this._sendRequest({
      method: "ipack/cancelsortbox",
      data: {
        SortBoxID,
        TooBigSkuIDs,
        isFailure,
        isPaused,
        approvedBy,
        isScanIdValidationCancelSortboxRequired,
      },
      headers: this._getAuthHeader(),
      run: this.server.postData,
    });
  }

  failureToDeliver(boxBarcode: string) {
    return this._sendRequest({
      method: "ipack/failuretodeliver",
      data: {
        boxBarcode,
      },
      headers: this._getAuthHeader(),
      run: this.server.getData,
    });
  }
  pollForBox() {
    return this._sendRequest({
      method: "ipack/pollforbox",
      data: {},
      headers: this._getAuthHeader(),
      run: this.server.postData,
    });
  }

  setBoxManually(boxBarcode: string){
    return this._sendRequest({
      method: "ipack/setbox",
      data: {
        boxBarcode,
      },
      headers: this._getAuthHeader(),
      run: this.server.postData,
    });
  }

      
  sendASPackageForNoValidation(boxBarcode: string) {
    return this._sendRequest({
      method: "ipack/SendASPackageForNoValidation",
      data: {
        boxBarcode,
      },
      headers: this._getAuthHeader(),
      run: this.server.postData,
    });
  }
}

export default new IPackEndpoints();
